import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AxsButtonComponent } from '@vanguard/axs-angular';
import { ModalFunctions } from '@vanguard/axs-core';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

@Component({
  selector: 'discover-modal',
  standalone: true,
  imports: [CommonModule, AxsButtonComponent],
  templateUrl: './discover-modal.component.html',
  styleUrl: './discover-modal.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DiscoverModalComponent implements OnInit, OnChanges {
  @Input() isOpen = false;
  @Output() isOpenChange = new EventEmitter<boolean>();

  @ViewChild('modal') modal: any;
  @ViewChild('dialog') dialog: any;

  discoverModalContent = content.Data.v4_rcc_root.content.discovermodal;
  commonContent = content.Data.v4_rcc_root.content.common;

  readonly researchSummaryLink =
    'https://corporate.vanguard.com/content/corporatesite/us/en/corp/articles/betr-way-assess-roth-ira-conversions.html';

  constructor(private readonly contentService: ContentService) {}

  ngOnInit(): void {
    this.initializeContent();
  }

  initializeContent(): void {
    this.contentService.getContent().subscribe((data) => {
      this.discoverModalContent = data.Data.v4_rcc_root.content.discovermodal;
      this.commonContent = data.Data.v4_rcc_root.content.common;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']?.currentValue) {
      setTimeout(() => this.openModal(), 0);
    }
  }

  openModal(): void {
    (this.modal.nativeElement as ModalFunctions).proxyShowModal();
    this.dialog.nativeElement.addEventListener(
      'close',
      () => {
        this.onModalClosed();
      },
      { once: true },
    );
  }

  closeModal(): void {
    if (!this.isOpen) {
      return;
    }
    (this.modal.nativeElement as ModalFunctions).proxyClose();
  }

  onModalClosed(): void {
    this.isOpenChange.emit(false);
  }
}
